import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M12 22C6.47967 21.994 2.00606 17.5204 2 12V11.8C2.10993 6.30455 6.63459 1.92797 12.1307 2.0009C17.6268 2.07382 22.0337 6.5689 21.9978 12.0654C21.9619 17.5618 17.4966 21.9989 12 22ZM4 12.172C4.0475 16.5903 7.66772 20.1335 12.086 20.086C16.5043 20.0385 20.0475 16.4183 20 12H12V4.00002C7.58401 4.00553 4.00551 7.58402 4 12V12.172Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "PieChart25"
);
